// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a8100a09","845":"f738ba0e"}[chunkId] + ".chunk.js";
};